export default __webpack_public_path__ + "static/media/EXEMPLO 3.4c5c004f.jpg";